<template>
  <el-container>
    <img class="banner" src="../assets/img/newbanner2.jpg" />
    <div class="bg-box">
      <el-aside width="315px">
        <left-menu :menuList="menuList" @activeMeun="activeMeun"></left-menu>
      </el-aside>
      <div class="right-text">
        <div class="title1">{{ activeText }}</div>
        <div class="title2">{{ activeTextEng }}</div>
        <el-divider></el-divider>
        <div class="join-class" v-show="activeText == '人才理念'">
          <el-col :span="10">
            <div class="left-class">
              <span v-for="(item, index) in joinTextList" :key="index">
                <img align="absmiddle" src="../assets/img/checked.png" />
                {{ item }}
              </span>
            </div>
          </el-col>
          <el-col :span="14">
            <img class="join2-img" src="../assets/img/join2.jpg" />
          </el-col>
        </div>
        <div
          class="join-title"
          v-for="p in joinList"
          :key="p.title + 1"
          v-show="activeText == '招贤纳士'"
        >
          <div class="title">{{ p.title }}</div>
          <!--20210923更新招聘数据时注释-->
          <!--  <div class="text">工作地点：{{p.location}}</div>
                    <div class="text bottom-class">工作性质：{{p.type}}</div> -->
          <div class="text">岗位职责：</div>
          <div class="text" v-for="e in p.responsibility" :key="e + 2">
            {{ e }}
          </div>
          <div class="text top-class">任职标准：</div>
          <div class="text" v-for="(j, k) in p.require" :key="k + 3">
            {{ j }}
          </div>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import leftMenu from "@/components/leftMenu";
export default {
  name: "join",
  components: {
    leftMenu,
  },
  data() {
    return {
      menuList: ["人才理念", "招贤纳士"],
      activeText: "",
      joinTextList: ["事业留人", "感情留人", "待遇留人", "我留人"],
      joinList: [
        {
          title: "销售总监",
          location: "北京",
          type: "全职",
          responsibility: [
            "1、负责所辖厂家商务政策解读，宣贯和应用；",
            "2、制定部门年度预算及岗位目标分解；",
            "3、制定对应的销售策略、销售计划；",
            "4、负责本区域竞争对手和市场分析；",
            "5、负责销售流程的制定和优化；",
            "6、负责销售计划的跟进；",
            "7、负责组织各类营销活动；",
            "8、负责提升销售满意度调查结果；",
            "9、负责处理客户的重大投诉和大客户的销售跟进、关系维护；",
            "10、负责团队建设及各类外联管理；",
            "11、督导配合二手车业务的开展；",
          ],
          require: [
            "1、大专以上学历；",
            "2、三年以上销售管理经验；",
            "3、热衷汽车贸易行业，有较好的市场敏锐度；",
            "4、有较强的团队领导力和执行力；",
          ],
        },
        {
          title: "售后经理",
          location: "北京",
          type: "全职",
          responsibility: [
            "1、根据公司下达的销售任务，制定售后战略和售后计划，并监督执行；",
            "2、了解市场动态，制定和更新服务策略；",
            "3、负责客户开发与管理，维护拓展对外业务合作关系；",
            "4、负责与事故相关的所有业务管理，包括事故SA及全车间的技术、质检、调度等工作；",
            "5、负责各类考核指标落地；",
            "6、负责各类制度、报表的起草、上报及审批后的落地；",
          ],
          require: [
            "1、大专以上学历，有3年以上汽车行业工作经验；",
            "2、熟悉国家汽车相关法律法规；具有丰富的服务营销知识及丰富汽车理论知识和汽车维修经验；",
            "3、语言表达能力强、有丰富的管理经验、沟通协调能力、培训能力、应变能力及市场洞察力；",
            "4、熟悉运用现代化办公室系统、汽车维修管理软件；",
            "5、有驾驶并熟练驾驶，有4s店管理工作经验；",
          ],
        },
      ],
    };
  },

  computed: {
    activeTextEng() {
      switch (this.activeText) {
        case "人才理念":
          return "TALENT CONCEPT";
          break;
        case "招贤纳士":
          return "TALENT RECRUITMENT";
          break;

        default:
          break;
      }
    },
  },
  methods: {
    activeMeun(data) {
      let a;
      console.log(a);
      this.activeText = data;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-aside {
  overflow: hidden;
}
/deep/ .el-divider {
  background-color: $font-color-gary2;
  margin-bottom: 30px;
}
.el-container {
  flex-wrap: wrap;
}
.banner {
  margin-bottom: 30px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}
.bg-box {
  width: 100%;
  min-width: 1050px;
  box-sizing: border-box;
  display: flex;
  margin: 0 15%;
  .right-text {
    max-width: 964px;
    min-width: 600px;
    text-align: left;
    margin: 0 0 100px 50px;
    .title1 {
      margin: 0px 0 4px 0;
      font-size: $font-size-lv1;
      color: $font-color-main;
    }
    .title2 {
      margin: 0 0 35px 0;
      font-size: $font-size-lv5;
      color: $font-color-gary1;
    }
    span {
      font-size: $font-size-lv3;
      color: $font-color-gary1;
      line-height: 36px;
    }
  }
}
.join-class {
  max-width: 964px;
  min-width: 600px;
  img {
    margin-left: 10%;
  }
  .join2-img {
    max-width: 372px;
    min-width: 260px;
  }
  .left-class {
    text-align: left;
    max-width: 382px;
    min-width: 354px;
    span {
      font-size: $font-size-lv2;
      color: $font-color-black;
      float: left;
      margin: 0 10% 10% 0;
      img {
        margin: 0 10px 0 0;
        vertical-align: middle;
      }
    }
  }
}
.join-title {
  margin-bottom: 40px;
  .title {
    text-align: left;
    font-size: $font-size-lv2;
    color: $font-color-main;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .text {
    font-size: $font-size-lv3;
    color: $font-color-black;
    line-height: 32px;
  }
  .bottom-class {
    margin-bottom: 40px;
  }
  .top-class {
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/join.vue